// CareBot mock 数据生成
// 阶段 1：Rails /api/carebot/* 未实现前，前端用 mock 跑通 UI/UX
// 阶段 2：在 .env.local 设 VITE_USE_CAREBOT_MOCK=false 切真实接口

import {
  CareBotFamilyInviteResponse,
  CareBotOnboardResponse,
} from '../types/carebotOnboarding';

const SHORT_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // 去掉易混淆字符 0/O/1/I

const CAREBOT_PUBLIC_BASE = 'https://carebot.example.com';

// 基于 assessmentId 稳定生成 shortCode，保证幂等：
// 同一 assessmentId 多次点击返回完全一致的短码 / 链接
function stableShortCode(seed: string, length = 6): string {
  let hash = 5381;
  for (let i = 0; i < seed.length; i++) {
    hash = ((hash << 5) + hash + seed.charCodeAt(i)) >>> 0;
  }
  let code = '';
  for (let i = 0; i < length; i++) {
    code += SHORT_CODE_ALPHABET[hash % SHORT_CODE_ALPHABET.length];
    hash = Math.floor(hash / SHORT_CODE_ALPHABET.length) + i + 17;
  }
  return code;
}

function isoDaysFromNow(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString();
}

export function buildMockOnboardResponse(
  assessmentId: string | number
): CareBotOnboardResponse {
  const seed = `onboard-${assessmentId}`;
  const shortCode = stableShortCode(seed, 6);

  return {
    ok: true,
    elder: {
      elderId: `elder_mock_${stableShortCode(`elder-${assessmentId}`, 8).toLowerCase()}`,
      familyId: `family_mock_${stableShortCode(`family-${assessmentId}`, 8).toLowerCase()}`,
      isExisting: false,
    },
    icopeReport: {
      reportId: `icope_report_mock_${assessmentId}`,
      status: 'ready',
    },
    elderClaim: {
      shortCode,
      claimUrl: `${CAREBOT_PUBLIC_BASE}/i/${shortCode}`,
      expiresAt: isoDaysFromNow(7),
    },
    subscription: {
      status: 'active',
      tier: 'trial',
      expiresAt: isoDaysFromNow(30),
    },
  };
}

export function buildMockFamilyInviteResponse(
  assessmentId: string | number,
  familyPhone: string
): CareBotFamilyInviteResponse {
  const seed = `family-${assessmentId}-${familyPhone}`;
  const shortCode = stableShortCode(seed, 6);

  return {
    ok: true,
    familyInvite: {
      shortCode,
      inviteUrl: `${CAREBOT_PUBLIC_BASE}/f/${shortCode}`,
      expiresAt: isoDaysFromNow(7),
    },
    smsSent: false, // mock 阶段短信通道未对接，强制走链接展示分支
  };
}

// 模拟网络延时
export function mockDelay(min = 600, max = 1200): Promise<void> {
  const ms = Math.floor(min + Math.random() * (max - min));
  return new Promise((resolve) => setTimeout(resolve, ms));
}
